import { MobileDroplist } from '@sbercloud/uikit-product-mobile-dropdown';

import { HeaderRightSectionProvider } from '@/context/HeaderRightSection';
import { useHeaderRightSectionCtx } from '@/hooks/ctx';

import { Burger } from './Burger';
import { BurgerContent } from './BurgerContent';
import { ConsoleButton } from './ConsoleButton';
import s from './styles.module.scss';

function RightSection() {
  const { isOpenBurgerContent, toggleIsOpenBurgerContent } = useHeaderRightSectionCtx();
  return (
    <>
      <div className={s.burger_block_wrapper}>
        <MobileDroplist
          onOpenChange={toggleIsOpenBurgerContent}
          open={isOpenBurgerContent}
          items={[{ content: <BurgerContent /> }]}
        >
          <Burger />
        </MobileDroplist>
      </div>
      <div className={s.console_button_wrapper}>
        <ConsoleButton size='s' />
      </div>
    </>
  );
}

export function HeaderRightSection() {
  return (
    <HeaderRightSectionProvider>
      <RightSection />
    </HeaderRightSectionProvider>
  );
}
